/* ============================================
   HISTORIAL DE BUSQUEDA + MODAL LEGACY (search-modal)
============================================ */
export async function guardarHistorial(query) {
    if (!query) return;
    try {
        const res = await fetch("/api/search-historial", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]').content
            },
            body: JSON.stringify({ query })
        });
        // 401/403 = guest — fail silently
    } catch (_) {}
}

export async function borrarResultadoHistorial(id) {
    try {
        const res = await fetch("/delete-search-historial", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]').content
            },
            body: JSON.stringify({ id })
        });

        const data = await res.json();

        if (!data.success) {
            console.error("Error al borrar:", data.message);
            return;
        }
        cargarHistorial();

    } catch (error) {
        console.error("Error al borrar historial:", error);
    }
}

window.openSearchModal = async () => {
     const userIdInput = document.getElementById('user_id');


    if (!userIdInput || !userIdInput.value.trim()) {
        return;
    }

    const modal = document.getElementById('search-modal');
    modal.classList.remove('hidden');
    modal.classList.add('flex');

    document.getElementById('opciones-filtros-nav')?.classList.add('hidden');
    
    cargarHistorial();
};

window.openSearchModalMovil = async () => { 
     const userIdInput = document.getElementById('user_id');


    if (!userIdInput || !userIdInput.value.trim()) {
        return;
    }

    const modal = document.getElementById('search-modal-movil');
    modal.classList.remove('hidden');
    modal.classList.add('flex');
    
    cargarHistorial();
};

export function modalSearchOutUser(){
    const searchInput = document.getElementById("search-input-alg");
    const searchInputMobile = document.getElementById("search-input-alg-mb");
    const userIdInput = document.getElementById("user_id");

    const handleInputIfNotLogged = () => {

        if (userIdInput && userIdInput.value.trim()) return;

        const modal = document.getElementById('search-modal');
        modal.classList.remove('hidden');
        modal.classList.add('flex');

        document.getElementById('opciones-filtros-nav')?.classList.add('hidden');
    };

    searchInput?.addEventListener("input", handleInputIfNotLogged);
    searchInputMobile?.addEventListener("input", handleInputIfNotLogged);
}

async function cargarHistorial() {
    let noIsMobile = document.getElementById('mobile-search').classList.contains('hidden');
    const content = noIsMobile == false ?  document.getElementById('content-modal-search-movil') :  document.getElementById('content-modal-search');
    
    if (!content) return;
    // Invitado: sin usuario no hay historial, evitar el 401 del fetch
    if (!document.getElementById('user_id')?.value?.trim()) return;
    try {
        const res = await fetch('/search-historial', {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        });

        content.innerHTML = '';

        if (res.status === 401) return;

        const data = await res.json();

        if (!data.success || !data.data.length) {
            content.innerHTML = '<p class="text-gray-500">No hay búsquedas recientes</p>';
            return;
        }
        const ul = document.createElement('ul');
        ul.classList.add('space-y-2');

        data.data.forEach(hit => {
        const li = document.createElement('li');

        // NOMBRE DEL TEXTO
        const nameSpan = document.createElement("span");
        nameSpan.textContent = hit.query;
        nameSpan.classList.add("cursor-pointer", "text-coral-600", "hover:underline", "font-medium");

        // CLICK PARA BUSCAR
        nameSpan.addEventListener('click', () => {
            const input = document.getElementById('search-input-alg');
            const inputMobile = document.getElementById('search-input-alg-mb');

            if (input){
                input.value = hit.query;
                window.location.href = `/search?q=${encodeURIComponent(hit.query)}`;
            } 
            if (inputMobile){
                inputMobile.value = hit.query;
                window.location.href = `/search?q=${encodeURIComponent(hit.query)}`;
            }
        });

        // BOTÓN X
        const deleteBtn = document.createElement("span");
        deleteBtn.innerText = "✕";  
        deleteBtn.className = "ml-3 text-gray-500 cursor-pointer font-bold";

        deleteBtn.addEventListener("click", (event) => {
            event.stopPropagation();
            borrarResultadoHistorial(hit.id);
        });

        li.className = "flex justify-between items-center";
        li.appendChild(nameSpan);
        li.appendChild(deleteBtn);

        ul.appendChild(li);
    });


        content.appendChild(ul);

    } catch (err) {
        console.error('Error al traer historial:', err);
        content.innerHTML = '<p class="text-red-500">Error al cargar historial</p>';
    }
}

window.closeSearchModal = () => {
    const modal = document.getElementById('search-modal');

    modal.classList.add('hidden');
    modal.classList.remove('flex');
    document.getElementById('opciones-filtros-nav')?.classList.remove('hidden');
};

window.closeSearchModalMovil = () => {
    const modal = document.getElementById('search-modal-movil');

    modal.classList.add('hidden');
    modal.classList.remove('flex');
    document.getElementById('opciones-filtros-nav')?.classList.remove('hidden');
};

document.addEventListener('click', (e) => {
    const modal = document.getElementById('search-modal');
    if (modal && !modal.classList.contains('hidden') && e.target === modal) {
        closeSearchModal();
    }
});

document.addEventListener("click", (e) => {
    const searchInput = document.getElementById("search-input-alg");
    const searchModal = document.getElementById("search-modal");

    if (!searchModal) return;
        if (!searchModal.contains(e.target) && e.target !== searchInput) {
            searchModal.classList.add("hidden");
        }
});
